export default __webpack_public_path__ + "static/media/MA Logo 2 - no text.10344ea2.png";